export const formatNumber = (number: number) => {
  return new Intl.NumberFormat(["ban", "id"]).format(number);
};
